<template>
  <section v-if="videos && videos.length" class="graduates-thoughts container">
    <div
      v-if="videoJsLoaded"
      class="videos"
    >
      <Slider class="col-12" :class="{ dark: !light }" class-name="landing">
        <h2 slot="heading" class="title-highlight" :class="titleClass || 'h1'">
          <slot name="title" />
        </h2>
        <slot slot="subtitle" name="subtitle" class="subtitle" />
        <div
          v-for="(video, i) in videos" :key="i" slot="slide"
          class="col col-3 sm-6"
        >
          <div class="single-video">
            <div class="video-image" @click="openVideo(video.id)">
              <img :src="getVideoThumb(video.image || video.name)">
              <span />
            </div>
            <p class="name">
              {{ video.name }}
            </p>
            <p v-if="video.job" class="job">
              {{ video.job }}
            </p>
            <p class="from">
              {{ video.from }}
            </p>
            <p v-if="video.quote" class="quote">
              <IconQuote />
              {{ video.quote }}
            </p>
          </div>
        </div>
      </Slider>
    </div>
  </section>
</template>

<script>
import Slider from '../components/Slider';
import IconQuote from '../assets/svg/icon-quote-testimonials.svg?vue-component';

export default {
  components: { Slider, IconQuote },
  props: {
    videos: { type: Array, default: () => ([]), required: true },
    light: { type: Boolean },
    videoJsLoaded: Boolean,
    titleClass: { type: String, default: '' },
  },
  methods: {
    openVideo(videoId) {
      this.$store.dispatch('modals/open', {
        name: 'video', videoId: `${videoId}`, posterBackgroundSize: 'contain', classes: 'not-rounded video-screen',
      });
    },
    getVideoThumb(image) {
      // eslint-disable-next-line import/no-dynamic-require
      return require(`../assets/images/campaigns/video-thumbs/vthumb-${image.toLowerCase()}.webp`);
    },
  },
};
</script>

<style lang="scss" scoped>
.graduates-thoughts {
  h2 {
    max-width: 720px;
    margin: 0 auto var(--spacing-36);
    text-align: center;
    color: var(--main-light);

    .highlighted {
      font-weight: 700;
      color: var(--accent);
    }
  }

  .videos {
    .single-video {
      .video-image {
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        display: flex;
        cursor: pointer;

        img {
          width: 100%;
        }

        span {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          position: absolute;
          z-index: 1;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);

          &:before {
            content: "";
            width: 12px;
            height: 14px;
            position: absolute;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMDgyMDMxMiAxNS41NjExTDEyLjg3MjggOC4xOTQxMUwwLjA4MjAzMTIgMC44MjcxNDhWMTUuNTYxMVoiIGZpbGw9IiMwMDBDMUYiLz4KPC9zdmc+Cg==);
            background-size: auto;
            background-repeat: no-repeat;
            top: 50%;
            left: 55%;
            transform: translate(-50%, -50%);
          }
        }

        &:hover {
          span {
            background: rgba(255, 255, 255, 0.7);
          }

          img {
            transform: scale(1.02);
            transition: ease all var(--duration);
          }
        }
      }

      .name {
        line-height: 150%;
        margin: 12px 0 2px;
        color: var(--main-light);
      }

      .from {
        font-size: 12px;
        font-weight: 400;
        color: var(--main-dark-light-4);
        margin: 0;
      }

      .job {
        font-size: 14px;
        font-weight: 400;
        color: var(--main-light-shade-4);
        line-height: 1.3;
        margin: 4px 0;
      }

      .quote {
        font-size: 14px;
        font-weight: 400;
        line-height: 1.3;

        svg {
          display: block;
        }
      }
    }
  }

  @include bp($bp-mobile) {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
